import { ScreenWaveLoader } from '@/shared'
import loadable from '@loadable/component'

export const XLMoteLandingScreenLazy = loadable(
  () => import('./XLMoteDynamicLandingScreen'),
  {
    fallback: <ScreenWaveLoader />
  }
)
